import { createContext, Dispatch, SetStateAction, useContext } from 'react';
import { MenuItemResponse, MenuType } from 'api/models';
import { noop } from 'utils/noop';

/** A cart line. `day` and `menuType` are carried because the cart spans multiple days/menus and
 * MenuItemResponse (unlike the legacy GoogleMenuItemResponse) has no menu date or menu type. */
export type Meal = {
  item: MenuItemResponse;
  quantity: number;
  day: string;
  menuType: MenuType;
};

export type Meals = {
  [id: string]: Meal;
};

export type CartContextType = {
  meals: Meals;
  setMeals: Dispatch<SetStateAction<any>>;
  addMeal: (meal: MenuItemResponse, day: string, menuType: MenuType) => void;
  removeMeal: (meal: MenuItemResponse, day: string, menuType: MenuType) => void;
  updateOrder: (meals: Meals) => void;
  clearOrder: () => void;
};

export const initialOrderContext: CartContextType = {
  meals: {},
  setMeals: noop,
  addMeal: noop,
  removeMeal: noop,
  updateOrder: noop,
  clearOrder: noop,
};

const cartContext = createContext<CartContextType>(initialOrderContext);

export const useCartContext = () => useContext(cartContext);
export const CartProvider = cartContext.Provider;
export const CartConsumer = cartContext.Consumer;
